var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconArrowRightGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1242 2208",
    style: {
      enableBackground: "new 0 0 1242 2208"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#919294;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M837.06,1707.55c-10.87,0-21.65-4.73-28.98-13.85L308.5,1073.78l557.89-557.89c14.53-14.53,38.06-14.53,52.59,0 c14.53,14.52,14.53,38.08,0,52.59l-510.62,510.65L866,1647.02c12.88,15.99,10.36,39.41-5.62,52.3 C853.5,1704.86,845.24,1707.55,837.06,1707.55z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.45,1864.22c-41.04,0-82.08-15.66-113.41-46.99c-62.66-62.61-62.66-164.21,0-226.82l474.73-474.73 L239.04,640.94c-62.66-62.61-62.66-164.21,0-226.82c62.66-62.66,164.16-62.66,226.82,0l588.14,588.14 c62.66,62.61,62.66,164.21,0,226.82l-588.14,588.14C434.53,1848.56,393.49,1864.22,352.45,1864.22z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightGray);
export default __webpack_public_path__ + "static/media/icon-arrow-right-gray.150974793d29c37594ed8cc0df3ed8c8.svg";
export { ForwardRef as ReactComponent };